import { Payment } from '../payment';
import { School } from '../school';


export const enum InvoiceStatus {
    'DRAFT',
    'FINALIZED',
    'PARTIALLY_PAID',
    'PAID',
    'REVERSED'
}

export class Invoice {
    constructor(
        public id?: number,
        public invoiceNumber?: string,
        public documentUrl?: string,
        public subTotal?: number,
        public taxRate?: number,
        public taxAmount?: number,
        public total?: number,
        public currencyCode?: number,
        public school?: School,
        public dateIssued?: any,
        public dueDate?: any,
        public notes?: string,
        public payment?: Payment,
        public status?: InvoiceStatus,
        public billTo?: string,
        public billingAddress?: string,
        public billingCountryId?: number,
        public billingCountry?: string,
        public billingCityId?: number,
        public billingCity?: string
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/invoice/invoice.model.ts